import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommercialRoutingModule } from './commercial-routing.module';
import { CommercialComponent } from './commercial/commercial.component';
import { PartnershipComponent } from './partnership/partnership.component';
import { PlayerComponent } from './player/player.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { BoundaryComponent } from './boundary/boundary.component';
import { AdvertisingComponent } from './advertising/advertising.component';
import { OfficialpartnersComponent } from './officialpartners/officialpartners.component';
import { IndiafixtureComponent } from './indiafixture/indiafixture.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { HospitalityComponent } from './hospitality/hospitality.component';



@NgModule({
  declarations: [CommercialComponent, PartnershipComponent, PlayerComponent, BoundaryComponent, AdvertisingComponent, OfficialpartnersComponent, IndiafixtureComponent, HospitalityComponent],
  imports: [
    CommonModule,
    SlickCarouselModule,
    CommercialRoutingModule,
    FormsModule,
    SharedModule
  ]
})
export class CommercialModule { }
